import type { PartnersContent, PartnerId } from "../i18n/types";

/*
 * Partners — infrastructure & collaborators, the quiet beat after the
 * consortium trust section.
 *
 * The logoWall's message is "built by universities"; this section answers
 * with "…and runs on national sovereign infrastructure." Deliberately
 * quieter than the logo wall: smaller marks, role captions, no cards —
 * a footnote to the trust story, not a second logo wall.
 *
 * Styles live in sections.css (the "Infrastructure partners" block);
 * only the markup and logo assets live here.
 */

/** Partner logo assets — structural, keyed by partner id. Monochrome
 * white PNGs in public/assets/partners/, inverted in light mode by the
 * same trick the consortium marks use. */
const PARTNER_LOGOS: Record<PartnerId, { src: string; width: number; height: number }> = {
  deic: { src: "/assets/partners/DeiC.png", width: 150, height: 44 },
  danfoss: { src: "/assets/partners/Danfoss.svg", width: 150, height: 44 },
  hpe: { src: "/assets/partners/HPE.webp", width: 150, height: 44 },
  dcai: { src: "/assets/partners/DCAI.png", width: 150, height: 44 },
  dfm: { src: "/assets/partners/DFM.png", width: 190, height: 44 },
};

const PARTNER_ORDER: PartnerId[] = ["deic", "danfoss", "hpe", "dcai", "dfm"];

export function renderPartners(t: PartnersContent): HTMLElement {
  const root = document.createElement("section");
  root.className = "section section--tight partners";
  root.id = "partners";
  root.innerHTML = `
    <div class="page">
      <div class="partners__head" data-reveal>
        <h2 class="section__title">${t.title}</h2>
        <p class="section__lead">${t.lead}</p>
      </div>
      <div class="partners__grid" aria-label="${t.gridAriaLabel}">
        ${PARTNER_ORDER.map((id, index) => {
          const logo = PARTNER_LOGOS[id];
          return `
            <a class="partners__mark" href="${t.partnerHrefs[id]}" target="_blank" rel="noreferrer" aria-label="${t.partnerNames[id]}" data-reveal style="--reveal-delay:${index * 60}ms">
              <img src="${logo.src}" alt="${t.partnerNames[id]}" width="${logo.width}" height="${logo.height}" loading="lazy" />
              <span class="partners__name">${t.partnerNames[id]}</span>
              <span class="partners__role">${t.partnerRoles[id]}</span>
            </a>
          `;
        }).join("")}
      </div>
    </div>
  `;
  return root;
}
